import React from "react";
import ReactHtmlParser from 'react-html-parser'; 

const Rate = ({rate})=>{
    var tmp = [];
    for (var i = 0; i < +rate; i++) {
        tmp.push('<img src="/images/product_detail/Default.png"/>');
      }
    if(tmp.length >0){
        return(
            <div className="rate-star">
                |
               {
                tmp.length > 0 ?(
                    tmp.map((item,i)=>(
                        ReactHtmlParser(item)
                       ))
                       
                ):(null)  
               }
            </div>
        )
    }else{ return null}

}

export default Rate;